import type { Build } from '@todesktop/shared';
import CliError, { getErrorMessage } from './CliError';
import subscribeToFirebaseDoc from './subscribeToFirebaseDoc';

export default async function subscribeToBuild({
  appId,
  buildId,
  onDataReceived,
  userId,
}: {
  appId: string;
  buildId: string;
  onDataReceived: (data?: Build) => void;
  userId: string;
}) {
  try {
    return await subscribeToFirebaseDoc<Build>(
      `users/${userId}/applications/${appId}/builds/${buildId}`,
      async ({ data }) => {
        onDataReceived(data);
      },
    );
  } catch (e) {
    throw new CliError(
      `Failed while subscribing to build: ${getErrorMessage(e)}`,
      {
        cause: e instanceof Error ? e : undefined,
        type: 'build-error',
      },
    );
  }
}
